import { defineComponent, h } from "vue";
import { Slot } from "./Slot.mjs";
const Primitive = defineComponent({
  name: "Primitive",
  inheritAttrs: false,
  props: {
    asChild: {
      type: Boolean,
      default: false
    },
    as: {
      type: [String, Object],
      default: "div"
    },
    getProps: {
      type: Function,
      default: () => ({})
    },
    getAttrs: {
      type: Function,
      default: () => ({})
    }
  },
  setup(props, { attrs, slots }) {
    const asTag = props.asChild ? "template" : props.as;
    const SELF_CLOSING_TAGS = ["area", "img", "input"];
    return () => {
      const motionProps = props.getProps();
      const motionAttrs = props.getAttrs();
      let allAttrs = { ...motionAttrs, ...attrs };
      if (typeof asTag === "string" && SELF_CLOSING_TAGS.includes(asTag))
        return h(asTag, allAttrs);
      if (asTag !== "template") {
        if (motionProps.forwardMotionProps) {
          allAttrs = { ...motionProps, ...allAttrs };
        }
        return h(props.as, allAttrs, { default: slots.default });
      }
      return h(Slot, allAttrs, { default: slots.default });
    };
  }
});
export {
  Primitive
};
